import { useMemo } from "react";

import { match } from "ts-pattern";

import ClickhouseLogoSourceIconDark from "../../assets/components/sources/ClickhouseLogoSourceIconDark";
import ClickhouseLogoSourceIconLight from "../../assets/components/sources/ClickhouseLogoSourceIconLight";
import { GalaxyTheme } from "../../theme/constants";
import { useGalaxyTheme } from "../../theme/GalaxyTheme";

const ClickhouseLogomark = ({ height }: { height: number }) => {
  const { galaxyTheme } = useGalaxyTheme();

  const logo = useMemo(() => {
    return match(galaxyTheme)
      .with(GalaxyTheme.DARK, () => <ClickhouseLogoSourceIconLight height={height} />)
      .with(GalaxyTheme.LIGHT, () => <ClickhouseLogoSourceIconDark height={height} />)
      .exhaustive();
  }, [galaxyTheme, height]);

  return logo;
};

export default ClickhouseLogomark;
